<script>
export default {
    name: "CardInfoBL",
    props: {
        navires: {
            type: Array,
            required: true
        }
    },
    methods: {
        formatNumber(value) {
            if (value == null) return "";
            return new Intl.NumberFormat("fr-FR").format(value);
        },
        getQteClass(qte) {
            // Retourne la classe CSS basée sur la quantité
            return qte > 0 ? 'qte-restant' : 'qte-cloturee';
        }
    }
}
</script>

<template>
    <div class="dossier-grid">
        <div class="dossier-card"
             v-for="(navire, index) in navires" :key="index"
        >
            <!-- Bloc navire : icône + infos -->
            <div class="dossier-info">
                <!-- Colonne gauche / Haut sur mobile : icône -->
                <div class="dossier-info-left">
                    <div class="ship-icon-wrapper">
                        <i class="fa fa-ship"></i>
                    </div>
<!--                    <i class="fa fa-ship"></i>-->
                </div>

                <!-- Colonne droite / Bas sur mobile : infos -->
                <div class="dossier-info-right">
                    <!-- Nom navire -->
                    <div class="dossier-number">
                        {{ navire.nom_navire }}
                    </div>

                    <!-- Infos -->
                    <div class="info-row">
                        <span class="info-label">Arrivée :</span>
                        <span class="info-value">{{ navire.date_arriver_navire }}</span>
                    </div>
                    <div class="info-row">
                        <span class="info-label">Dans :</span>
                        <span class="info-value text-bold">{{ navire.nbre_jours }} jours</span>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<style scoped>
.dossier-card::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    height: 4px;
    background: linear-gradient(90deg, #076360, #0a7a77);
}
/* --- Grille des cartes --- */
.dossier-grid {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
    gap: 20px;
    padding: 10px;
}

/* --- Carte --- */
.dossier-card {
    background: white;
    border-radius: 15px;
    padding: 20px;
    transition: all 0.3s ease;
    box-shadow: 0 5px 15px rgba(0,0,0,0.08);
    border: 1px solid #e9ecef;
    position: relative;
    overflow: hidden;
}

.dossier-card:hover {
    transform: translateY(-8px);
    box-shadow: 0 15px 30px rgba(0,0,0,0.15);
    border-color: #076360;
}

/* --- Bloc navire --- */
.dossier-info {
    display: flex;
    align-items: center;
}

/* Colonne gauche (icône) */
.dossier-info-left {
    flex: 0 0 60px;
    display: flex;
    justify-content: center;
    align-items: center;
}

.dossier-info-left i {
    font-size: 36px;
    color: #076360;
}

/* Colonne droite (nom + infos) */
.dossier-info-right {
    flex: 1;
    display: flex;
    flex-direction: column;
    justify-content: center;
    padding-left: 10px;
}

/* --- Nom navire --- */
.dossier-number {
    font-size: 18px;
    font-weight: 700;
    color: #076360;
    margin-bottom: 8px;
}

/* --- Infos --- */
.info-row {
    display: flex;
    justify-content: space-between;
    margin-bottom: 4px;
    font-size: 14px;
}

.info-label {
    font-weight: 600;
    color: #6c757d;
}

.info-value {
    font-weight: 500;
    color: #212529;
}

.text-bold {
    font-weight: 700;
}

/* --- Responsive --- */
@media (max-width: 768px) {
    .dossier-info {
        flex-direction: column; /* pile verticale */
        text-align: center;
    }

    .dossier-info-left {
        margin-bottom: 10px; /* espace entre icône et texte */
    }

    .dossier-info-right {
        padding-left: 0;
        align-items: center; /* centrer contenu */
    }

    .info-row {
        justify-content: center;
        gap: 8px;
    }
}


.ship-icon-wrapper {
    width: 70px;
    height: 70px;
    background: linear-gradient(135deg, #076360, #0a7a77);
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    box-shadow: 0 8px 20px rgba(7, 99, 96, 0.3);
    transition: all 0.4s ease;
    position: relative;
    overflow: hidden;
}

.ship-icon-wrapper::before {
    content: '';
    position: absolute;
    top: -50%;
    left: -50%;
    width: 200%;
    height: 200%;
    background: linear-gradient(45deg, transparent, rgba(255, 255, 255, 0.2), transparent);
    transform: rotate(45deg);
    transition: all 0.6s ease;
}

.dossier-card:hover .ship-icon-wrapper::before {
    left: 100%;
}

.dossier-card:hover .ship-icon-wrapper {
    transform: rotate(5deg) scale(1.1);
    box-shadow: 0 12px 30px rgba(7, 99, 96, 0.4);
}

.ship-icon-wrapper i {
    font-size: 32px;
    color: white;
    z-index: 1;
}

</style>
